"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTransactionCategoriesForPayeeAction = exports.autoCategorizeTransactions = void 0;
const core_1 = require("companion-app-components/flux/core");
// Special action to adjust transactions after a GET
exports.autoCategorizeTransactions = core_1.actionHelpers.createAction('AUTO_CATEGORIZE_TRANSACTIONS');
// Special action to adjust transactions after a GET
exports.updateTransactionCategoriesForPayeeAction = core_1.actionHelpers.createAction('UPDATE_TRANSACTION_CATEGORIES_FOR_PAYEE_ACTION');
